module.exports = __webpack_public_path__ + "static/scale-model-of-visitors-center-in-lincoln-nebraska-1cabfc4a366cc09314b7a2fda559b4c9.png";